/**
* @author Vinny DeFrancesco
*/

const has = Object.prototype.hasOwnProperty;

function RefineTasksExplainerController($scope, $translate, schemaService) {
  $scope.refine = {
    priority: [],
    types: [],
    statuses: []
  };

  const directionMap = {
    asc: $translate.instant('CHRONOLOGICAL'),
    desc: $translate.instant('REVERSE_CHRONOLOGICAL')
  };

  const priorityMap = {
    1: $translate.instant('PRIORITY_LOW'),
    2: $translate.instant('PRIORITY_MEDIUM'),
    3: $translate.instant('PRIORITY_HIGH')
  };

  const sortMap = {
    createdDate: $translate.instant('CREATED_F'),
    deadline: $translate.instant('DEADLINE'),
    priority: $translate.instant('PRIORITY')
  };

  $scope.types = $scope.filterSet.getFilter('taskType');
  $scope.statuses = $scope.filterSet.getFilter('taskStatus');
  $scope.priority = $scope.filterSet.getFilter('taskPriority');
  $scope.sort = $scope.filterSet.getFilter('taskSort');
  $scope.direction = $scope.filterSet.getFilter('direction');

  let statusMap = {};
  schemaService.getTaskInfo('statuses')
    .then((data) => {
      const statusPayload = data
        .reduce((acc, status) => {
          acc[status.id] = status.name;
          return acc;
        }, {});

      statusMap = statusPayload;

      const payload = [];

      if ($scope.statuses.value) {
        if ($scope.statuses.value.length > 1) {
          $scope.statuses.value.forEach((status) => {
            payload.push(statusMap[status]);
          });
        } else {
          payload.push(statusMap[$scope.statuses.value]);
        }
      }
      for (let i = 0; i < payload.length; i += 1) {
        switch (payload[i]) {
          case 'Group Assigned':
            payload[i] = $translate.instant('TASK_META_GROUP_ASSIGNED').toLowerCase();
            break;
          case 'User Assigned':
            payload[i] = $translate.instant('TASK_META_USER_ASSIGNED').toLowerCase();
            break;
          case 'Claimed':
            payload[i] = $translate.instant('TASK_META_CLAIMED').toLowerCase();
            break;
          case 'Rejected':
            payload[i] = $translate.instant('TASK_META_REJECTED').toLowerCase();
            break;
          case 'Completed':
            payload[i] = $translate.instant('TASK_META_COMPLETED').toLowerCase();
            break;
          default:
            payload[i] = payload[i];
            break;
        }
      }
      $scope.refine.statuses = payload;
    });

  let typeMap = {};
  schemaService.getTaskInfo('types')
    .then((data) => {
      const typePayload = {};
      data.forEach((type) => {
        typePayload[type.id] = type.name;
      });

      typeMap = typePayload;

      const payload = [];

      if ($scope.types.value) {
        $scope.types.value = [].concat($scope.types.value);

        if ($scope.types.value.length > 1) {
          $scope.types.value.forEach((type) => {
            payload.push(typeMap[type]);
          });
        } else {
          payload.push(typeMap[$scope.types.value]);
        }
      }

      $scope.refine.types = payload;
    });

  $scope.$watch('priority.value', (val) => {
    const payload = [];

    if (val) {
      [].concat(val)
        .forEach((priority) => {
          payload.push(priorityMap[priority]);
        });
    }

    $scope.refine.priority = payload;
  });

  $scope.$watch('sort.value', (val) => {
    $scope.refine.sort = sortMap[val];
  });

  $scope.$watch('direction.value', (val) => {
    $scope.refine.direction = directionMap[val];
  });

  $scope.$watch('types.value', (val) => {
    const payload = [];

    if (val) {
      [].concat(val)
        .forEach((type) => {
          if (has.call(typeMap, type)) {
            payload.push(typeMap[type]);
          }
        });
    }

    $scope.refine.types = payload;
  });

  $scope.$watch('statuses.value', (val) => {
    const payload = [];

    if (val) {
      [].concat(val)
        .forEach((status) => {
          payload.push(statusMap[status]);
        });
    }
    for (let i = 0; i < payload.length; i += 1) {
      switch (payload[i]) {
        case 'Group Assigned':
          payload[i] = $translate.instant('TASK_META_GROUP_ASSIGNED').toLowerCase();
          break;
        case 'User Assigned':
          payload[i] = $translate.instant('TASK_META_USER_ASSIGNED').toLowerCase();
          break;
        case 'Claimed':
          payload[i] = $translate.instant('TASK_META_CLAIMED').toLowerCase();
          break;
        case 'Rejected':
          payload[i] = $translate.instant('TASK_META_REJECTED').toLowerCase();
          break;
        case 'Completed':
          payload[i] = $translate.instant('TASK_META_COMPLETED').toLowerCase();
          break;
        default:
          payload[i] = payload[i];
          break;
      }
    }
    $scope.refine.statuses = payload;
  });
}

const controllerArray = [
  '$scope',
  '$translate',
  'schemaService',
  RefineTasksExplainerController
];

export default function (ngModule) {
  ngModule.controller('RefineTasksExplainerController', controllerArray);
}
